import { useEffect, useState } from 'react';
import { app } from '@microsoft/teams-js';
import { initTeams } from '../api/client';

export interface TeamsContext {
  theme: 'default' | 'dark' | 'contrast';
  initialized: boolean;
  /** True only when the Teams host answered; false in a plain browser tab. */
  inTeams: boolean;
  error: string | null;
}

export function useTeamsContext(): TeamsContext {
  const [state, setState] = useState<TeamsContext>({
    theme: 'default',
    initialized: false,
    inTeams: false,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await initTeams();
        const ctx = await app.getContext();
        if (cancelled) return;
        setState({
          theme: (ctx.app.theme as any) || 'default',
          initialized: true,
          inTeams: true,
          error: null,
        });
        app.registerOnThemeChangeHandler(t => {
          if (!cancelled) setState(s => ({ ...s, theme: t as any }));
        });
      } catch (e: any) {
        if (cancelled) return;
        // Outside Teams (a plain browser tab, or dev), fall through gracefully
        setState({
          theme: 'default',
          initialized: true,
          inTeams: false,
          error: import.meta.env.DEV ? null : e?.message || 'Teams init failed',
        });
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return state;
}
